import { call, put, takeLatest } from 'redux-saga/effects'
import { YoutubeActions, YoutubeTypes } from './youtubeSlice'
import api from '../../services/api'

function* youtubeQuotaSaga() {
  const response = yield call(api.getYouTubeQuota)
  if (response.ok) {
    yield put(YoutubeActions.youtubeQuotaSuccess(response.data))
  } else {
    yield put(YoutubeActions.youtubeQuotaFailure(response.problem))
  }
}

export default function* youtubeSaga() {
  yield takeLatest(YoutubeTypes.YOUTUBE_QUOTA_REQUEST, youtubeQuotaSaga)
}
